var installedModules = {};
var moduleToHandlerMapping = {
	79998: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(78281))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	81474: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(8568))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	32479: {
		getter: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(44)]).then(() => (() => (__webpack_require__(71659))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.17.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@grafana/faro-web-sdk",
	},
	12516: {
		getter: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(8), __webpack_require__.e(670), __webpack_require__.e(406)]).then(() => (() => (__webpack_require__(25731))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.14.10",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/material",
	},
	30775: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(18434))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.17.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@grafana/faro-web-tracing",
	},
	37270: {
		getter: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(8)]).then(() => (() => (__webpack_require__(32977))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.14.10",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/styles",
	},
	37895: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(44599))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.17.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@grafana/faro-react",
	},
	56022: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(57310))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "setimmediate",
	},
	87510: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(79865))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^11.18.6",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-i18next",
	},
	92771: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(78041))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.39.2",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-query",
	},
	97541: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(93805))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.4.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	78670: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(59431))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.10.4",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@emotion/react",
	},
	44044: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(26717))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.1.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "web-vitals",
	},
	53008: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(43979))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^15.8.1",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "prop-types",
	},
	39406: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(56272))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.10.4",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@emotion/styled",
	},
	1012: {
		getter: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(916)]).then(() => (() => (__webpack_require__(95171))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.0-develop.13",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@toorak/chatbot",
	},
	12448: {
		getter: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(226)]).then(() => (() => (__webpack_require__(28724))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "3.1.3",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@toorak/op-eventbus-sdk",
	},
	17614: {
		getter: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(535)]).then(() => (() => (__webpack_require__(7188))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.4.5",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@toorak/web-support-sdk",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"8": [
		53008
	],
	"44": [
		44044
	],
	"307": [
		12516,
		30775,
		37270,
		37895,
		56022,
		87510,
		92771,
		97541
	],
	"406": [
		39406
	],
	"474": [
		81474
	],
	"479": [
		32479
	],
	"670": [
		78670
	],
	"694": [
		1012,
		12448,
		17614
	],
	"998": [
		79998
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}